/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/Label',['pixi', 'absolute', 'lodash', "absolute/stringmanager"],

    function (PIXI, Absolute, _, StringManager) {

        var Label = function (config) {
            var defaultConfig = {
                icon: null,
                iconScale: 1,
                text: '',
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 40 + 'px Arial',
                    fontFamily: 'segoe',
                    fill: '#ffffff',
                    tint: 0xffffff,
                    align: 'left'
                }
            };
            this.initLabel(_.extend(defaultConfig, config));
        };

        Label.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        Label.prototype.initLabel = function (config) {
            PIXI.DisplayObjectContainer.call(this);
            this.config = config;

            this.icon = this.config.icon ? PIXI.Sprite.fromFrame(this.config.icon) : null;
            if (this.icon) {
                this.icon.scale.x = this.icon.scale.y = this.config.iconScale;
                this.addChild(this.icon);
            }

            this.setText(this.config.text);
        };

        Label.prototype.setText = function (text) {
            if (this.labelText) {
                this.removeChild(this.labelText);
            }
            this.labelText = new PIXI.Text(text, _.extend({}, this.config.letterStyle));
            var fontSize = StringManager.extractNumbersFromString(this.config.letterStyle.font);
            var isBold = this.config.letterStyle.font.toLowerCase().indexOf('base') !== -1;
            if (this.config.maxWidth) {
                Absolute.StringManager.shrinkToFit(this.labelText, fontSize, isBold ? 'Bold' : '', this.config.maxWidth);
            }
            if (this.icon) {
                this.labelText.x = this.icon.width + Absolute.Coords.x(15);
            } else {
                this.labelText.y = -Absolute.Coords.y(10);
            }
            this.addChild(this.labelText);
        };

        Label.prototype.onShow = function () {

        };

        return Label;

    });

